<!-- course-tree -->
<template>
  <ul
    :class="['course-tree', { 'root-node': !depth, 'tree-expand': expand, 'copy-node': isCopy }]"
    :style="{ maxHeight: `${maxHeight}px` }"
  >
    <li
      v-for="(treeNode, index) in treeNodeList"
      :key="treeNode.id"
      :class="[
        'tree-node',
        `depth${depth}`,
        {
          'leaf-node': !(treeNode.children && treeNode.children.length) && treeNode.resourceList,
        },
      ]"
    >
      <!-- 课程列表讲义过滤不展示 -->
      <div
        v-if="treeNode.studyResourceType !== 4"
        :class="[
          'tree-node-title',
          (treeNode.children && treeNode.children.length) || treeNode.studyResourceType === 0
            ? `tree-node-branch${depth}`
            : '',
        ]"
        @click="clickHandle(treeNode)"
      >
        <template v-if="treeType === 'learnGuideTree'">
          <GuideTreeItemCard
            :expand="treeNode.expand"
            :treeNode="treeNode"
            :learnData="learnData"
            :progress="getProgress(treeNode)"
            :catalogInfo="catalogInfo"
            @openApp="openDownLoadDialog"
          />
        </template>
        <template v-else>
          <DetailTreeItemCard :treeNode="treeNode" :expand="treeNode.expand" />
        </template>
      </div>
      <course-tree
        :ref="treeNode.id"
        v-if="treeNode.children && treeNode.children.length && !isCopy"
        :treeNodeInit="treeNode.children || []"
        :learningProgressList="learningProgressList"
        :treeNodeId="treeNode.id"
        :learnData="learnData"
        :parent="treeNode"
        :catalogInfo="catalogInfo"
        :treeType="treeType"
        :depth="depth + 1"
        :expand="treeNode.expand"
        :maxHeightInit="treeNode.maxHeight"
        @heightChange="heightCalc"
      />
      <course-tree
        :ref="`${treeNode.id}-copy`"
        v-if="treeNode.children && treeNode.children.length"
        :treeNodeInit="treeNode.children || []"
        :learningProgressList="learningProgressList"
        :treeNodeId="treeNode.id"
        :treeType="treeType"
        :learnData="learnData"
        :catalogInfo="catalogInfo"
        :depth="depth + 1"
        :expand="treeNode.expand"
        :isCopy="true"
        :style="{ position: isCopy ? 'static' : 'absolute' }"
      ></course-tree>
    </li>
    <DialogComponent ref="dialogComponent" dialogType="downloadApp" />
  </ul>
</template>

<script>
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';
import { reqCatalogService } from '@/api/catalog';
import { getTaskApi } from '@/api/learningGuidePage/index';
// eslint-disable-next-line import/extensions
import DetailTreeItemCard from '@/components/course/DetailTreeItemCard';
// eslint-disable-next-line import/extensions
import GuideTreeItemCard from '@/components/course/GuideTreeItemCard';
import DialogComponent from '../dialogComponent/dialogComponent.vue';

const MAX_HEIGHT_VALUE = 10000;
const MIN_HEIGHT_VALUE = 0;

export default {
  name: 'CourseTree',
  components: { DialogComponent, DetailTreeItemCard, GuideTreeItemCard },
  props: {
    treeNodeInit: {
      type: Array,
      default: () => [],
    },
    id: {
      type: Number,
    },
    depth: {
      type: Number,
      default: 0,
    },
    expand: {
      type: Boolean,
      default: false,
    },
    maxHeightInit: {
      type: Number,
      default: 0,
    },
    isCopy: {
      type: Boolean,
      default: false,
    },
    parent: {
      type: Object,
      default: () => ({}),
    },
    clickChild: {
      type: Boolean,
      default: true,
    },
    learnData: {
      type: Object,
      default: () => ({}),
    },
    treeNodeId: {
      type: Number,
      default: 0,
    },
    treeType: {
      type: String,
      default: '',
    },
    catalogInfo: {
      type: Object,
      default: () => ({}),
    },
    learningProgressList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState(['buyStatusForCourseList', 'courseBaseData', 'userInfo']),
  },
  watch: {
    maxHeightInit(val) {
      this.maxHeight = val;
    },
    expand(val) {
      this.maxHeight = val && this.expand ? MAX_HEIGHT_VALUE : MIN_HEIGHT_VALUE;
    },
    treeNodeInit(v) {
      // 数据改变时，重载数据
      if (!(typeof this.id === 'number') && v?.length) {
        if (!this.depth) this.treeNodeList = this.expandInit(this.treeNodeInit);
        else this.treeNodeList = v;
        if (this.depth) this.maxHeight = this.isCopy ? MAX_HEIGHT_VALUE : MIN_HEIGHT_VALUE;
      } else {
        this.treeNodeList = [];
      }
    },
  },
  data() {
    return {
      treeNodeList: [],
      maxHeight: MAX_HEIGHT_VALUE,
      // learningProgressList: [],
      catalogId: this.$route.query.catalogId,
    };
  },
  created() {},
  mounted() {
    if (!(typeof this.id === 'number') && this.treeNodeInit?.length) {
      if (!this.depth) this.treeNodeList = this.expandInit(this.treeNodeInit);
      else this.treeNodeList = this.treeNodeInit;
      if (this.depth) this.maxHeight = this.isCopy ? MAX_HEIGHT_VALUE : MIN_HEIGHT_VALUE;
    }
    if (typeof this.id === 'number' && !this.treeNodeInit?.length) {
      this.dataInit();
    }
  },
  methods: {
    getProgress(child) {
      const data = this.learningProgressList.find((item) => item.chapterId === child.id) || {};
      const progress = data.learnProgress || 0;
      // console.log(child.name, data, 3344, child, this.learningProgressList);
      return progress;
    },
    openDownLoadDialog() {
      this.$refs.dialogComponent.show = true;
    },
    dataInit() {
      reqCatalogService(this.id).then((catalogResponse) => {
        if (!this.depth) this.treeNodeList = this.expandInit(catalogResponse.data.courseNodes);
      });
    },
    expandInit(treeNodeList) {
      return treeNodeList.map((treeNode) => {
        if (treeNode.children) this.expandInit(treeNode.children);
        if (!treeNode.expand) {
          Object.assign(treeNode, { expand: false });
        } else {
          // 节点默认展开时，切换
          Object.assign(treeNode, { expand: false });
          this.$nextTick(() => {
            Object.assign(treeNode, { expand: true });
          });
          this.heightCalc(treeNode);
        }
        return treeNode;
      });
    },
    async clickHandle(treeNode) {

      if (treeNode?.children?.length) {
        Object.assign(treeNode, { expand: !treeNode.expand });
        if (this.clickChild && !treeNode.expand) {
          // 关闭子节点
          const currentVNode = this.$refs[treeNode.id]?.[0];
          currentVNode.treeNodeList.forEach((childNode) => {
            this.$refs[treeNode.id]?.[0].clickHandle();
            if (childNode.expand) currentVNode.clickHandle(childNode);
          });
        }
        this.$forceUpdate();
        this.heightCalc(treeNode);
      }
      this.$emit('treeNodeClick', treeNode);
      // app内跳到导学页，h5打开下载弹窗
      if (
        (treeNode?.studyResourceType === 2 || treeNode?.studyResourceType === 3) &&
        this.buyStatusForCourseList?.length > 0 &&
        this.courseBaseData.isRepeatBuy !== 1 &&
        this.userInfo.id &&
        this.treeType !== 'learnGuideTree'
      ) {
        if (this.$root.$data.isApp) {
          this.$sendToApp(
            'goDirectoryPage',
            { courseId: this.buyStatusForCourseList[0].id },
            false,
          );
        } else {
          const { id } = this.buyStatusForCourseList[0];
          const res = await this.entranceTask(id);
          if (res === 'unFinished') {
            if (this.$root.miniprogram) {
              this.$toast('请前往app完成入学任务后，即可查看课程视频');
            } else {
              this.$router.push({
                path: '/entranceTask',
                query: {
                  id,
                },
              });
            }
          } else if (res === 'finished') {
            if (this.$root.miniprogram) {
              wx.miniProgram.navigateTo({ url: `/myCourse/learningGuide/index?catalogId=${id}` });
            } else {
              this.$router.push({
                name: 'learningGuide',
                query: {
                  catalogId: this.buyStatusForCourseList[0].id,
                },
              });
            }
          }
        }
      }
    },
    async entranceTask(id) {
      const { code, data } = await getTaskApi(id);
      if (code === 0) {
        const { agreementId, agreementDone, examId, examDone, examinationFlag, examinationDone } =
          data;
        this.examId = examId;
        if (
          (agreementId && !agreementDone) ||
          (examId && !examDone) || (examinationFlag && !examinationDone)
        ) {
          return 'unFinished';
        }
        return 'finished';
      }
      return 'err';
    },
    heightCalc(treeNode) {
      this.$nextTick(() => {
        const that = this;
        Object.assign(treeNode, {
          maxHeight: that.$refs[`${treeNode.id}-copy`][0].$el.offsetHeight,
        });
        this.$forceUpdate();
        if (this.depth) this.$emit('heightChange', this.parent);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.course-tree {
  width: 100%;
  max-height: 0;
  overflow: hidden;
  background: #fff;
  transition: 0.2s max-height linear;

  .tree-node-title {
    display: flex;
    align-items: center;
    width: 100%;

    .record-icon {
      width: 29px;
      height: 29px;
      margin-right: 18px;

      img {
        width: 29px;
        height: 29px;
      }
    }

    .live-icon {
      margin-right: 18px;
      padding: 4px 18px;
      color: $theme_color;
      font-weight: 400;
      font-size: 24px;
      white-space: nowrap;
      border: 1.1px solid $theme_color;
      border-radius: 6px;
    }

    .item-title {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: keep-all;
    }

    .arrow-icon {
      flex: 1;
      text-align: right;

      i {
        color: #808080;
        font-size: 24px;
      }
    }

    .live-time {
      flex: 1;
      margin-left: 16px;
      line-height: 36px;
      white-space: nowrap;
      text-align: right;
    }
  }

  &.tree-expand {
    max-height: 10000px;
  }

  &.root-node {
    flex: 1;
    max-height: 10000px;
    padding: 0 36px;
  }

  &.copy-node {
    position: absolute;
    z-index: -1;
    opacity: 0;
    transition: none;
  }

  .tree-node {
    position: relative;

    .tree-node-title {
      font-size: 24px;
      border-bottom: 1.1px solid #f5f5f5;

      .item-title {
        line-height: 36px;
      }
    }

    &.leaf-node {
      .tree-node-title {
        color: #808080;
      }
    }
  }
}
</style>
